<template>
    <div class="referrals-body__email">

        <div class="referrals-body__switcher" :class="form.via">
            <button :class="{'active': isFormEmail }" @click="selectTab('email')">Invite By Email</button>
            <button :class="{'active': isFormPhone }" @click="selectTab('text')">Invite By Text</button>
            <button :class="{'active': isFormShare }" @click="selectTab('share')">Share Link</button>
        </div>

        <div class="referrals-body__form-wrap">

            <!-- Invite with Email -->
            <form id="refer-email"
                  :action="`/referrals`"
                  :class="{'active': isFormEmail }"
                  class="form no-validation"
                  method="post"
                  @submit.prevent="submit()">

                <div class="form__row">
                    <label>To</label>
                    <input name="email" type="email" v-model="form.email" placeholder="Enter Contact's Email">
                </div>
                <span v-if="form.errors.email" class="error" v-text="form.errors.email"></span>

                <div class="form__row">
                    <div class="form_group">
                        <input name="first_name" type="text" v-model="form.first_name" placeholder="First Name">
                        <span v-if="form.errors.first_name" class="error" v-text="form.errors.first_name"></span>
                    </div>
                    <div class="form_group">
                        <input name="last_name" type="text" v-model="form.last_name" placeholder="Last Name">
                        <span v-if="form.errors.last_name" class="error" v-text="form.errors.last_name"></span>
                    </div>
                </div>

                <div class="form__button">
                <button type="submit" :class="{ 'is-submitting': form.isSubmitted }" :disabled="form.isSubmitted" class="button">
                    {{ (form.isSubmitted && isFormEmail) ? 'Submitting' : 'Send Invite' }}
                    <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></button>
                </div>
            </form>

            <!-- Invite with Phone -->
            <form id="refer-text"
                  :class="{'active': isFormPhone }"
                  class='form no-validation'
                  @submit.prevent="submit()">

                <div class="form__row">
                    <label>To</label>
                    <international-phone id="phone_number"
                                         @validation="isValidPhoneNumber = $event"
                                         name="phone_number"
                                         class="phone-international"
                                         v-model="form.tel"
                                         placeholder="Enter Contact's Phone Number">
                    </international-phone>
                </div>
                <span v-if="form.errors.tel" class="error" v-text="form.errors.tel"></span>

                <div class="form__row">
                    <div class="form_group">
                        <input name="first_name" type="text" v-model="form.first_name" placeholder="First Name">
                        <span v-if="form.errors.first_name" class="error" v-text="form.errors.first_name"></span>
                    </div>
                    <div class="form_group">
                        <input name="last_name" type="text" v-model="form.last_name" placeholder="Last Name">
                        <span v-if="form.errors.last_name" class="error" v-text="form.errors.last_name"></span>
                    </div>
                </div>

                <div class="refer-text-preview">
                    <h3>Message Preview</h3>
                    <p>Congrats! You scored an invite to join Well Traveled from {{ currentUser.full_name }}!🎉 Well Traveled is a members-only social platform built for modern travelers (like you). Here’s your link to skip the waitlist and join our community today: (link will be generated)</p>
                </div>

                <div class="form__button">
                <button :class="{ 'is-submitting': form.isSubmitted }" :disabled="form.isSubmitted" class="button">
                    {{ (form.isSubmitted && isFormPhone) ? 'Submitting' : 'Send Invite' }}
                    <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></button>
                </div>
            </form>

            <!-- Invite with Code -->
            <form id="refer-share"
                  action="/referrals"
                  :class="{'active': isFormShare }"
                  class="form no-validation"
                  @submit.prevent="copyShareLink()">
                <div class="form__row">
                    <input name="sharelink"
                           type="text"
                           id="sharelink"
                           :value="url(`/invite/${currentUser.share_link}`)"
                           @focus="$event.target.select()">
                </div>
                <div class="form__button">
                    <button type="submit"  class="button">
                        {{ (isCopied && isFormShare ) ? 'Copied' : 'Copy Link' }}
                        <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                    </button>
                </div>
            </form>

        </div>
    </div>
</template>

<script>

import Alert from '@/classes/Alert'
import Form from '@/classes/Form'
import InternationalPhone from '@/components/InternationalPhone'

export default {

    props: ['currentUser'],

    components: {
        InternationalPhone
    },

    data() {
        return {
            isCopied: false,
            isValidPhoneNumber: false,
            form: new Form({
                email: '',
                tel: '',
                first_name: null,
                last_name: null,
                message: null,
                via: 'email',
            })
        }
    },

    methods: {

        copyShareLink() {
            let shareInput = document.querySelector('#sharelink')
            shareInput.select()
            document.execCommand('copy');
            this.isCopied = true;
        },

        selectTab(tab){
            this.form.errors.clear()
            this.form.via = tab
        },

        submit() {

            if (this.form.via == 'share') {
                return;
            }

            if(this.isFormPhone && !this.isValidPhoneNumber) {
                this.form.errors.add("tel", "Please enter a valid phone number.")
                return
            }

            this.form.post('/referrals')
                .then(response => {
                    eventBus.$emit('update-referrals', response.referrals)
                    Alert.success('The invitation was sent!', {
                        showCancelButton: false,
                        showCloseButton: true,
                        showConfirmButton: false,
                    })
                    this.form.via = 'email'
                });
        },

        url(params){
            return config.url + params;
        }
    },

    computed:{
        isFormShare(){
            return this.form.via == 'share';
        },

        isFormEmail(){
            return this.form.via == 'email';
        },

        isFormPhone(){
            return this.form.via == 'text';
        },
    }
}
</script>
